
export const CANAL_CARDAPIO = 'cardapio';
export const CANAL_TABLET = 'tablet';

export function itensDoCanal(banner, canal) {
    return (banner || []).filter(item => item && (item.canal || CANAL_CARDAPIO) === canal);
}
